import React, { useState, useEffect } from 'react';
import { Card, Typography, Button, Upload, message, Form, Input, Switch, Select, Row, Col } from 'antd';
import { UploadOutlined, SettingOutlined } from '@ant-design/icons';
import api from '../api';

const { Title, Text } = Typography;

function ConfigPage() {
  const [configs, setConfigs] = useState({});
  const [logoUrl, setLogoUrl] = useState('');
  const [splashUrl, setSplashUrl] = useState('');
  const [settings, setSettings] = useState({});

  const loadConfigs = async () => {
    try {
      const { config } = await api.get('/admin/config');
      const map = {};
      config.forEach(c => { map[c.key] = JSON.parse(c.value); });
      setConfigs(map);
      setLogoUrl(map.app_logo?.url || '');
      setSplashUrl(map.app_splash?.url || '');
      setSettings(map.app_settings || {});
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    loadConfigs();
  }, []);

  const saveConfig = async (key, value) => {
    try {
      await api.post('/admin/config', { key, value });
      message.success('保存成功');
      loadConfigs();
    } catch (e) {
      message.error('保存失败');
    }
  };

  return (
    <>
      <Title level={4}>应用配置</Title>
      <Row gutter={24}>
        <Col span={8}>
          <Card title="应用信息" extra={<SettingOutlined />}>
            <Form layout="vertical">
              <Form.Item label="应用名称">
                <Input
                  value={configs.app_name?.name || '云信'}
                  onChange={(e) => saveConfig('app_name', { ...configs.app_name, name: e.target.value })}
                />
              </Form.Item>
              <Form.Item label="副标题">
                <Input
                  value={configs.app_name?.subtitle || ''}
                  onChange={(e) => saveConfig('app_name', { ...configs.app_name, subtitle: e.target.value })}
                />
              </Form.Item>
            </Form>
          </Card>
        </Col>

        <Col span={8}>
          <Card title="Logo 与启动图">
            <div style={{ marginBottom: 16 }}>
              <Text>Logo 地址</Text>
              <Input
                value={logoUrl}
                onChange={(e) => saveConfig('app_logo', { url: e.target.value })}
                style={{ marginTop: 8 }}
                placeholder="/uploads/logo.png"
              />
            </div>
            <div>
              <Text>启动图地址</Text>
              <Input
                value={splashUrl}
                onChange={(e) => saveConfig('app_splash', { url: e.target.value })}
                style={{ marginTop: 8 }}
                placeholder="/uploads/splash.png"
              />
            </div>
          </Card>
        </Col>

        <Col span={8}>
          <Card title="功能开关">
            <Form.Item label="允许注册">
              <Switch
                checked={settings.enableRegistration ?? true}
                onChange={(v) => saveConfig('app_settings', { ...settings, enableRegistration: v })}
              />
            </Form.Item>
            <Form.Item label="允许小程序">
              <Switch
                checked={settings.enableMiniProgram ?? true}
                onChange={(v) => saveConfig('app_settings', { ...settings, enableMiniProgram: v })}
              />
            </Form.Item>
            <Form.Item label="允许好友申请">
              <Switch
                checked={settings.enableFriendRequest ?? true}
                onChange={(v) => saveConfig('app_settings', { ...settings, enableFriendRequest: v })}
              />
            </Form.Item>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ConfigPage;
